module.exports = __webpack_public_path__ + "img/testimonial_layout1.eaad633e.png";